import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LogIn, Lock } from 'lucide-react';

interface LoginPromptProps {
  title: string;
  description: string;
  featureName: string;
  icon?: React.ReactNode;
  redirectUrl?: string;
}

export const LoginPrompt: React.FC<LoginPromptProps> = ({ 
  title, 
  description, 
  featureName,
  icon,
  redirectUrl
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const returnUrl = redirectUrl || `${location.pathname}${location.search}${location.hash}`;

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gradient-to-br from-purple-50 to-white">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl border border-purple-200 p-8 text-center">
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 rounded-full bg-purple-100 flex items-center justify-center">
            {icon || <Lock className="w-10 h-10 text-purple-600" />}
          </div>
        </div>
        
        <h2 className="text-2xl font-bold text-gray-900 mb-3">
          {title}
        </h2>
        
        <p className="text-gray-600 mb-6 leading-relaxed">
          {description}
        </p>
        
        <div className="bg-purple-50 border border-purple-200 rounded-lg p-4 mb-6">
          <p className="text-sm text-purple-800 font-medium">
            <strong>Why login?</strong>
          </p>
          <ul className="text-left text-sm text-purple-700 mt-2 space-y-1">
            <li>• Track your progress and achievements</li>
            <li>• Compete on the leaderboard</li>
            <li>• Save your streak and daily stats</li>
            <li>• Unlock badges and rewards</li>
          </ul>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-3">
          <button
            onClick={() => navigate('/login', { state: { from: returnUrl } })}
            className="flex-1 flex items-center justify-center gap-2 px-6 py-3 bg-gradient-to-r from-purple-500 to-purple-700 text-white rounded-lg font-semibold hover:from-purple-600 hover:to-purple-800 transition-all shadow-md hover:shadow-lg"
          >
            <LogIn className="w-5 h-5" />
            Login
          </button>
          <button
            onClick={() => navigate('/signup', { state: { from: returnUrl } })}
            className="flex-1 px-6 py-3 border-2 border-purple-500 text-purple-600 rounded-lg font-semibold hover:bg-purple-50 transition-all"
          >
            Create Account
          </button>
        </div>
      </div>
    </div>
  );
};

